
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogData } from './ConfirmDialogData';
@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styles: [`
  .header, .dialog-message {
      text-transform: lowercase;
  }
  .header::first-letter, .dialog-message::first-letter {
      text-transform: uppercase;
  }
  .btn-cancel {
      background-color: red;
      color: #fff;
  }
`]
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData, private mdDialogRef: MatDialogRef<ConfirmDialogComponent>) {
  }
  public close(value?: boolean) {
    this.mdDialogRef.close(value);
  }
  public cancel() {
    this.close(false);
  }
  public confirm() {
    this.close(true);
  }
  public secondOptionConfirm() {
    this.close(undefined);
  }
}


